import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clamp } from "lodash";
import { cn as clsx } from "../../helpers/react.js";
import { pickIntent } from "../../helpers/ui.js";
import { isFiniteNumber } from "../../helpers/utils.js";
import { withThemeAndSize } from "../withThemeAndSize/index.js";
import '../../assets/index41.css';const frame = "_frame_9wed8_1";
const status = "_status_9wed8_9";
const primary = "_primary_9wed8_31";
const secondary = "_secondary_9wed8_36";
const critical = "_critical_9wed8_41";
const success = "_success_9wed8_46";
const warning = "_warning_9wed8_51";
const hidden = "_hidden_9wed8_56";
const cell = "_cell_9wed8_64";
const label = "_label_9wed8_71";
const progress = "_progress_9wed8_75";
const filler = "_filler_9wed8_89";
const s = {
  frame,
  status,
  primary,
  secondary,
  critical,
  success,
  warning,
  hidden,
  cell,
  label,
  progress,
  filler
};
const TURNAROUND_FRAME_INTENT = pickIntent(["secondary", "primary", "critical", "success", "warning"]);
const padTo2Digits = (num) => num.toString().padStart(2, "0");
const formatTime = (milliseconds) => {
  if (!Number.isFinite(milliseconds)) {
    return "";
  }
  const minutes = Math.floor(milliseconds / 6e4);
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  return `${padTo2Digits(hours)}h ${padTo2Digits(remainingMinutes)}m`;
};
const INTENT_CLASSNAME_MAP = {
  [TURNAROUND_FRAME_INTENT.PRIMARY]: s.primary,
  [TURNAROUND_FRAME_INTENT.SECONDARY]: s.secondary,
  [TURNAROUND_FRAME_INTENT.CRITICAL]: s.critical,
  [TURNAROUND_FRAME_INTENT.WARNING]: s.warning,
  [TURNAROUND_FRAME_INTENT.SUCCESS]: s.success
};
const SemiFiller = /* @__PURE__ */ jsxs("svg", { width: "10", height: "16", viewBox: "0 0 10 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsx("rect", { x: "4", y: "14", width: "2", height: "2", fill: "currentColor" }),
  /* @__PURE__ */ jsx("rect", { x: "4", y: "10", width: "2", height: "2", fill: "currentColor" }),
  /* @__PURE__ */ jsx("rect", { x: "4", y: "6", width: "2", height: "2", fill: "currentColor" }),
  /* @__PURE__ */ jsx("rect", { x: "4", y: "2", width: "2", height: "2", fill: "currentColor" }),
  /* @__PURE__ */ jsx("rect", { x: "2", y: "12", width: "2", height: "2", fill: "currentColor" }),
  /* @__PURE__ */ jsx("rect", { x: "2", y: "8", width: "2", height: "2", fill: "currentColor" }),
  /* @__PURE__ */ jsx("rect", { x: "2", y: "4", width: "2", height: "2", fill: "currentColor" }),
  /* @__PURE__ */ jsx("rect", { x: "2", width: "2", height: "2", fill: "currentColor" }),
  /* @__PURE__ */ jsx("rect", { x: "8", y: "10", width: "2", height: "2", fill: "currentColor" }),
  /* @__PURE__ */ jsx("rect", { x: "8", y: "2", width: "2", height: "2", fill: "currentColor" }),
  /* @__PURE__ */ jsx("rect", { x: "6", y: "12", width: "2", height: "2", fill: "currentColor" }),
  /* @__PURE__ */ jsx("rect", { x: "6", y: "4", width: "2", height: "2", fill: "currentColor" }),
  /* @__PURE__ */ jsx("rect", { y: "14", width: "2", height: "2", fill: "currentColor" }),
  /* @__PURE__ */ jsx("rect", { y: "10", width: "2", height: "2", fill: "currentColor" }),
  /* @__PURE__ */ jsx("rect", { y: "6", width: "2", height: "2", fill: "currentColor" }),
  /* @__PURE__ */ jsx("rect", { y: "2", width: "2", height: "2", fill: "currentColor" })
] });
const Status = withThemeAndSize(
  forwardRef(
    ({ className, percentValue, label: label2, timeLabel = "", customMessage, ...rest }, ref) => {
      const clampedPercentValue = percentValue ? clamp(percentValue, 0, 100) : null;
      const fillerValue = Math.floor((isFiniteNumber(clampedPercentValue) ? clampedPercentValue : 0) / 10);
      return /* @__PURE__ */ jsxs("div", { ...rest, ref, className: clsx(s.status, className), children: [
        /* @__PURE__ */ jsx("span", { className: clsx(s.cell, s.label), children: label2 }),
        clampedPercentValue !== null && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsxs("span", { className: clsx(s.cell, s.progress), children: [
            Boolean(fillerValue) && /* @__PURE__ */ jsx(
              "span",
              {
                className: s.filler,
                style: {
                  "--filler-value": fillerValue + 1
                }
              }
            ),
            fillerValue < 10 && SemiFiller
          ] }),
          /* @__PURE__ */ jsx("span", { className: s.cell, children: `${clampedPercentValue}%` })
        ] }),
        /* @__PURE__ */ jsx("span", { className: s.cell, children: timeLabel }),
        customMessage && /* @__PURE__ */ jsx("span", { className: s.cell, children: customMessage })
      ] });
    }
  )
);
const Frame = withThemeAndSize(
  forwardRef(
    ({ className, children, intent = TURNAROUND_FRAME_INTENT.SECONDARY, hidden: hidden2, ...rest }, ref) => {
      return /* @__PURE__ */ jsx(
        "div",
        {
          ...rest,
          ref,
          className: clsx(s.frame, INTENT_CLASSNAME_MAP[intent], className, {
            [s.hidden]: hidden2
          }),
          children
        }
      );
    }
  )
);
const TurnaroundFrame = {
  Frame,
  Status,
  formatTime
};
export {
  INTENT_CLASSNAME_MAP,
  TURNAROUND_FRAME_INTENT,
  TurnaroundFrame
};
